module.exports = __webpack_public_path__ + "static/media/logo ta fotke.cf5544f6.png";